export const LIFECYCLE_DATE_ORDER_MESSAGE = 'Lancement ≤ dernière livraison < fin de vente'

export const lifecycleDatesOutOfOrder = (
  launchDate: string | null,
  lastDeliveryDate: string | null,
  endDate: string | null,
): boolean =>
  (launchDate !== null && lastDeliveryDate !== null && launchDate > lastDeliveryDate) ||
  (launchDate !== null && endDate !== null && launchDate >= endDate) ||
  (lastDeliveryDate !== null && endDate !== null && lastDeliveryDate >= endDate)
